app.directive('assignmentList', function() {
  return {
    restrict: 'E',
    transclude: true,
    scope:{
      assignments:'=assignments',
      newAssignments:'=newassignments',
      selectAssignment: '&selectassignment'
    },
    templateUrl: '/student/partials/directives/assignmentList.html',
    controller: 'assignmentListCtrl',
  };
});

app.controller('assignmentListCtrl',function($rootScope, $scope) {
  $scope.Date = Date;
  $scope.a = 'hate';

});
